import React, { useState, useEffect, useRef } from 'react';
import InfoCard2 from './InfoCard2';

const EventListView = (events) => {
    const features = events?.events?.features || [];
    const [firstItem, ...restItems] = features;

    return (
        <div>
            <div className="wrapper">
                <div className="scrollable-list">

                    {/* Top section title */}
                    {firstItem && (
                        <>
                            <h2 style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>Featured Event</h2>
                            <div className="top-section">
                                <InfoCard2 item={firstItem.properties} />
                            </div>
                        </>
                    )}
                    <hr />
                    {/* Remaining section title */}
                    {restItems.length > 0 && (
                        <>
                            <h2 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1rem' }}>All Events</h2>
                            <ul style={{ padding: 0, listStyleType: 'none' }}>
                                {restItems.map((item, index) => (
                                    <InfoCard2 key={index} item={item.properties} />
                                ))}
                            </ul>
                        </>
                    )}

                </div>
            </div>
        </div>


    );
};

export default EventListView;

